// extracted by mini-css-extract-plugin
export var select = "sorting-colors-with-select-module--select--v7gsh";